import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { useTheme } from "hooks";

export const SuspenseECF = () => {
  const { theme } = useTheme();
  return (
    <>
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          zIndex: "9999999",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {}
        <Spinner
          style={{
            width: "4rem",
            height: "4rem",
            color: theme.color1,
          }}
          animation="border"
        />
      </div>
    </>
  );
};

export default SuspenseECF;
